import UserSwitchContext from "@/components/user-switch-context";
import { useCallback, useContext } from "react";
import { useUserSwitchLogic } from "./use-user-switch-logic";

const useUserSwitchAnimation = () => {
  const result = useContext(UserSwitchContext);

  if (!result) {
    throw new Error("useUserSwitchAnimation must be used within a UserSwitchProvider");
  }

  const { processUser, skipUser, returnUser } = useUserSwitchLogic();
  const { handleRightClick, handleSkip, handleSwipeLeft, handleSwipeRight } = result;

  const updatedHandleRightClick = useCallback(() => handleRightClick(processUser), [processUser, handleRightClick]);
  const updatedHandleSkip = useCallback(() => handleSkip(skipUser), [skipUser, handleSkip]);
  const updatedHandleSwipeLeft = useCallback(() => handleSwipeLeft(processUser), [processUser, handleSwipeLeft]);
  const updatedHandleSwipeRight = useCallback(() => handleSwipeRight(returnUser), [returnUser, handleSwipeRight]);

  return {
    ...result,
    handleRightClick: updatedHandleRightClick,
    handleSkip: updatedHandleSkip,
    handleSwipeLeft: updatedHandleSwipeLeft,
    handleSwipeRight: updatedHandleSwipeRight,
  };
};

export default useUserSwitchAnimation;
